import { ref } from 'vue'

interface ConfirmDialogOptions {
  icon?: Component
  title?: string
  description?: string
  confirmText?: string
  cancelText?: string
  variant?: 'default' | 'destructive'
}

const isOpen = ref(false)
const options = ref<ConfirmDialogOptions>({})
let resolveFn: ((confirmed: boolean) => void) | null = null

export function useConfirmDialog() {
  function confirm(dialogOptions: ConfirmDialogOptions = {}): Promise<boolean> {
    options.value = {
      icon: dialogOptions.icon,
      title: dialogOptions.title || 'Are you sure?',
      description: dialogOptions.description || '',
      confirmText: dialogOptions.confirmText || 'Confirm',
      cancelText: dialogOptions.cancelText || 'Cancel',
      variant: dialogOptions.variant || 'default',
    }
    isOpen.value = true

    return new Promise<boolean>((resolve) => {
      resolveFn = resolve
    })
  }

  function confirmAction() {
    isOpen.value = false
    resolveFn?.(true)
    resolveFn = null
  }

  function cancelAction() {
    isOpen.value = false
    resolveFn?.(false)
    resolveFn = null
  }

  return {
    isOpen,
    options,
    confirm,
    confirmAction,
    cancelAction,
  }
}
